import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      businessConciergeService: {
        BUSINESS_CONCIERGE_SERVICE: 'Business Concierge Service',
        BUSINESS_CONCIERGE_CONTENT: `After submitting the form below, our experts will process your Business Concierge request according to its urgency - Express or Standard.
        We will do our best to meet the delivery date.<br/> However, there may be times when processing your request takes longer because data availability depends on external factors.
        In that case, we will inform you in advance and resend the expected delivery date.
        <br/> Once delivered, the requested files will be uploaded and available to review in your FiinGate Library.<br/>
        Please submit your Business Concierge request by completing the following form.`,
        COMPANY_NAME: 'Company Name',
        COUNTRY_JURISDICTION: 'Country/Jurisdiction',
        REGISTRATION_NO: 'Registration Number',
        HISTORICAL_DATA: 'Historical data',
        PHONE_NUMBER: 'Contact Phone',
        EMAIL_ADDRESS: 'Contact Email',
        INFORMATION_REQUIREMENTS: 'Information Requirements',
        CANCEL: 'Cancel',
        SUBMIT: 'Submit Request',
        REGISTER_DATA: 'Register data',
        FINANCIAL_DATA: 'Financial data',
        STANDARD: 'Standard',
        EXPRESS: 'Express',
        REQUIRED_FIELD: 'This is a required field!',
        INVALID_EMAIL: 'Invalid email address. Please enter the correct email',
        RADIO_SELECT_NOTE: `We offer 2 types of order: Standard and Express, each with its own delivery time and fee.
        <br/> If you select Express, you will receive your documents faster; however, the fee will be higher than that of the Standard.`,
        INVALID_PHONE: 'Invalid phone number. Please enter the correct number',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      businessConciergeService: {
        BUSINESS_CONCIERGE_SERVICE: 'Dịch Vụ Business Concierge',
        BUSINESS_CONCIERGE_CONTENT: `Sau khi gửi biểu mẫu, các chuyên gia của chúng tôi sẽ xử lý yêu cầu tùy theo mức độ khẩn cấp  – nhanh hoặc tiêu chuẩn.
       Chúng tôi sẽ cố gắng cung cấp kết quả trong thời gian bạn đã chọn.
       <br/>Do tính khả dụng của dữ liệu phụ thuộc vào các yếu tố bên ngoài, quá trình xử lý yêu cầu của bạn có thể lâu hơn thời gian đã chọn. Trong trường hợp đó, chúng tôi sẽ gửi lại thời gian giao kết quả dự kiến.
       <br/>Khi có kết quả, báo cáo sẽ được tải lên tại mục Thư viện của bạn trên FiinGate.<br/>
        Gửi yêu cầu dịch vụ Business Concierge bằng cách điền vào mẫu sau.`,
        COMPANY_NAME: 'Tên Công Ty',
        COUNTRY_JURISDICTION: 'Quốc Gia/Khu Vực Pháp Lý',
        REGISTRATION_NO: 'Số Đăng Ký Doanh Nghiệp',
        HISTORICAL_DATA: 'Dữ liệu lịch sử',
        PHONE_NUMBER: 'Số Điện Thoại Liên Hệ',
        EMAIL_ADDRESS: 'Email Liên Hệ',
        INFORMATION_REQUIREMENTS: 'Thông tin yêu cầu',
        CANCEL: 'Hủy',
        SUBMIT: 'Gửi yêu cầu',
        REGISTER_DATA: 'Dữ liệu đăng ký',
        FINANCIAL_DATA: 'Dữ liệu tài chính',
        STANDARD: 'Tiêu chuẩn',
        EXPRESS: 'Nhanh',
        REQUIRED_FIELD: 'Đây là 1 trường bắt buộc!',
        INVALID_EMAIL:
          'Email không hợp lệ. Vui lòng nhập địa chỉ email chính xác',
        RADIO_SELECT_NOTE: `Chúng tôi cung cấp 2 loại đơn đặt hàng: Tiêu chuẩn và Nhanh, mỗi loại có thời gian xử lý và mức phí riêng.
        <br/> Nếu bạn chọn đơn giao Nhanh, bạn sẽ nhận kết quả sớm hơn và trả phí cao hơn so với loại Tiêu chuẩn.`,
        INVALID_PHONE:
          'Số điện thoại không hợp lệ. Vui lòng nhập số điện thoại chính xác',
      },
    },
  }),
)
